import React from 'react'
import "./Extra.css"
import { HiLocationMarker } from 'react-icons/hi'
import CountUp from "react-countup";
import { motion } from 'framer-motion';
function Extra() {
  return (
    <section className="extra-wrapper">
        
        <div className="padding innerWidth flexCenter extra-container">
            <div className="flexColStart extra-left">
                <div className="extra-title">
                    <div className="blueCircle"></div>
                    <motion.h1
                    initial={{y:"2rem", opacity:0}}
                    animate={{y:0,opacity:1}}
                    transition={{
                      duration:2,
                      type:"ease-in"
                    }}>
                        Discover <br />most Perfect <br /> Property
                    </motion.h1>
                </div>
                <div className=" flexColStart extra-des">
                    <span className='secondaryText'>Find Beautiful Properties that suite you</span>
                    <span className='secondaryText'>You will not face difficulty in finding best recidence</span>
                </div>

          <div>
            <div className="flexCenter search-bar">
              <HiLocationMarker color="blue" size={25} >
                
              </HiLocationMarker>
              <input type="text" name="" id="" />
                <button className="button">search</button>

            </div>
          </div>
          <div className="flexCenter stats">
            <div className="flexColCenter stat">
              <span>
                  <CountUp start={8500} end={9000} duration={4} />
                  <span>+</span>
              </span>
              <span className='secondaryText'>Preninum Property</span>
            </div>
            <div className="flexColCenter  stat">
              <span>
                  <CountUp start={8500} end={9000} duration={4} />
                  <span>+</span>
              </span>
              <span className='secondaryText'>Happy Costuers</span>
            </div>
            <div className="flexColCenter  stat">
              <span>
                  <CountUp start={50} end={90} duration={4} />
                  <span>+</span>
              </span>
               <span className='secondaryText'>Award Winning</span>
              
            </div>
          </div>

            </div>
            <div className="flexCenter extra-right">
          <motion.div className="image-container"
           initial={{x:"7rem", opacity:0}}
                    animate={{x:0,opacity:1}}
                    transition={{
                      duration:2,
                      type:"ease-in"
                    }}>
            <img src="./mainimage.jpg" alt="main-image"/>
          </motion.div>
          </div>
        </div>
    </section>
  )
}

export default Extra
